import {
  deleteApi,
  getApi,
  postApi,
  putApi,
  patchApi,
  postFormApi,
  patchFormApi,getBlobApi,
  postFormStreamApi,
  putSimpleApi,
  getFetchAuthOptions
} from "./axiosService";
import axiosService from "./axiosService";
import { baseUrl } from "../utils/Constant";
import { applyLiveFxFromPricePayload } from "../utils/euroCoinUtils";

const withLiveFx = async (request) => {
  const data = await request;
  applyLiveFxFromPricePayload(data);
  return data;
};

export const registerApi = (data) => {
  return postApi("register", data);
};
export const registerSubAdminApi = (data) => {
  return postApi("registerSubAdmin", data);
};
export const addUserByEmailApi = (data) => {
  return postApi("addUserByEmail", data);
};
export const exportExcelApi = () => {
  return getApi("exportExcel");
};
export const loginApi = (data) => {
  return postApi("login", data);
};
export const userCryptoCardApi = (data) => {
  return postApi("userCryptoCard", data);
};
export const userCryptoCardStatusApi = (userId, action) => {
  return postApi("userCryptoCard", { userId, action });
};
export const logoutApi = (data) => {
  return getApi("logout", data);
};

export const allUsersApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`allUser${queryString ? `?${queryString}` : ''}`, {});
};
export const getCoinsUserApi = (id) => {
  return withLiveFx(getApi(`getCoinsUser/${id}`));
};
export const getCryptoNewsApi = () => getApi("cryptoNews");
export const signleUsersApi = (id) => {
  return getApi(`singleUser/${id}`);
};
export const uploadUserAvatarApi = (userId, data) => {
  if (data instanceof FormData) {
    return postFormApi(`user/avatar/${userId || ""}`, data);
  }
  return postApi(`user/avatar/${userId || ""}`, data);
};
export const removeUserAvatarApi = (userId) => {
  return deleteApi(`user/avatar/${userId || ""}`);
};
export const getKycDocumentApi = (userId, docType) => {
  return getBlobApi(`kycDocument/${userId}/${docType}`, {}, "application/pdf");
};
export const getNotificationsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`getNotifications${queryString ? `?${queryString}` : ''}`);
};
export const deleteTransactionApi = (userId, id) => {
  return getApi(`deleteTransaction/${userId}/${id}`);
};
export const getHtmlDataApi = () => {
  return getApi(`getHtmlData`);
};
export const setHtmlDataApi = (data) => {
  return patchApi(`setHtmlData`, data);
};
export const updateSignleUsersApi = (id, data) => {
  return postApi(`updateSingleUser/${id}`, data);
};
export const applyCreditCardApi = (data) => {
  return postApi(`applyCreditCard`, data);
};
export const updateOldUserCoins = () => {
  return patchApi(`updateCoins`);
};
export const updateSignleUsersStatusApi = (id, data) => {
  return postApi(`updateSingleUserStatus/${id}`, data);
};
export const getMyComplianceStatusApi = () => {
  return getApi("my/compliance-status");
};
export const updateUserComplianceRestrictionApi = (id, data) => {
  return postApi(`updateUserComplianceRestriction/${id}`, data);
};
export const sendEmailCodeApi = (data) => {
  return postApi(`sendEmail`, data);
};
export const bypassSingleUserApi = (id) => {
  return patchApi(`bypassSingleUser/${id}`);
};
export const getCoinsApi = (id) => {
  return withLiveFx(getApi(`getCoins/${id}`));
};

export const patchCoinsApi = (id) => {
  return patchApi(`addCoins/${id}`);
};
export const updateCoinAddressApi = (id, data) => {
  return patchApi(`updateCoinAddress/${id}`, data);
};
export const updateNewCoinAddressApi = (id, data) => {
  return patchApi(`updateNewCoinAddress/${id}`, data);
};
export const requestCoinActivationApi = (id, data) => {
  return patchApi(`requestCoinActivation/${id}`, data);
};
export const requestWalletIntegrationApi = (id) => {
  return postApi(`requestWalletIntegration/${id}`);
};
export const updateWalletIntegrationStatusApi = (id, data) => {
  return putSimpleApi(`updateWalletIntegrationStatus/${id}`, data);
};
export const getWalletIntegrationStatusApi = (id) => {
  return getApi(`walletIntegrationStatus/${id}`);
};
export const createTransactionApi = (id, data) => {
  return patchApi(`createTransaction/${id}`, data);
};
export const createUserStocksApi = (id, data) => {
  return postApi(`createUserStocks/${id}`, data);
};
export const createUserTransactionApi = (id, data) => {
  return patchApi(`/createUserTransaction/${id}`, data);
};
export const createUserTransactionWithdrawSwapApi = (id, data) => {
  return patchApi(`/createUserTransactionWithdrawSwap/${id}`, data);
};
export const markTrxCloseApi = (id, Coinid) => {
  return patchApi(`/markTrxClose/${id}/${Coinid}`);
};
export const createUserTransactionDepositSwapApi = (id, data) => {
  return patchApi(`/createUserTransactionDepositSwap/${id}`, data);
};

export const updateTransactionApi = (id, data) => {
  return patchApi(`updateTransaction/${id}`, data);
};
export const getTransactionsApi = () => {
  return getApi(`getTransactions`);
};
export const getEachUserApi = (id, data) => {
  return getApi(`getEachUser/${id}`, data);
};
export const getUserCoinApi = (id, data) => {
  return withLiveFx(getApi(`getUserCoin/${id}`, data));
};
export const updateNotificationStatusApi = (id, status) => {
  return getApi(`updateNotificationStatus/${id}/${status}`);
};
export const verifySingleUserApi = (data) => {
  return patchFormApi(`verifySingleUser`, data);
};
export const getsignUserApi = (data) => {
  return patchApi(`getsignUser`, data);
};
export const verifyEmailApi = (data) => {
  return getApi(`${data.id}/verify/${data.token}`, data);
};
export const deleteEachUserApi = (id) => {
  return deleteApi(`deleteEachUser/${id}`, id);
};
export const UnassignUserApi = (id, subAdminId) => {
  const query = subAdminId ? `?subAdminId=${encodeURIComponent(subAdminId)}` : "";
  return deleteApi(`UnassignUser/${id}${query}`);
};
export const deleteUserStocksApi = (coindId, id) => {
  return deleteApi(`deleteUserStocksApi/${id}/${coindId}`, id, coindId);
};
export const deleteUserTokensApi = (coindId, id) => {
  return deleteApi(`deleteUserTokens/${id}/${coindId}`, id, coindId);
};
export const updateKycApi = (id, data) => {
  return patchApi(`updateKyc/${id}`, data);
};
export const deleteKycDocumentApi = (userId, docType) => {
  return deleteApi(`kycDocument/${userId}/${docType}`, userId, docType);
};
export const sendTicketApi = (data) => {
  return postApi(`sendTicket`, data);
};
export const uploadFilesApi = (id, data) => {
  return postFormApi(`uploadFiles/${id}`, data);
};
export const getAllDataApi = (id) => {
  return getApi(`getAllData/${id}`);
};
export const deleteSingleFileApi = (_id) => {
  return getApi(`deleteSingleFile/${_id}`);
};
export const PaymentsApi = (id, data) => {
  return patchApi(`createAccount/${id}`, data);
};

export const addCardApi = (id, data) => {
  return patchApi(`addCard/${id}`, data);
};
export const deletePaymentApi = (id, pId) => {
  return getApi(`deletePayment/${id}/${pId}`);
};
export const createTicketApi = (data) => {
  if (data instanceof FormData) {
    return postFormApi(`createTicket`, data);
  }
  return postApi(`createTicket`, data);
};
export const getUserTicketsApi = (id) => {
  return getApi(`getUserTickets/${id}`);
};
export const getIndivTicketApi = (id, ticketId) => {
  return getApi(`getIndivTicket/${id}/${ticketId}`);
};
export const adminTicketsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`admin/tickets${queryString ? `?${queryString}` : ''}`);
};
export const updateMessageApi = (ticketData) => {
  if (ticketData instanceof FormData) {
    return patchFormApi(`updateMessage`, ticketData);
  }
  return patchApi(`updateMessage`, ticketData);
};
export const updateTicketStatusApi = (data) => {
  return patchApi(`updateTicketStatus`, data);
};
export const editTicketMessageApi = (userId, ticketId, messageId, data) => {
  return patchApi(`ticketMessage/${userId}/${ticketId}/${messageId}`, data);
};
export const deleteTicketMessageApi = (userId, ticketId, messageId) => {
  return deleteApi(`ticketMessage/${userId}/${ticketId}/${messageId}`);
};
export const getTicketAttachmentApi = (userId, ticketId, messageId, attachmentIndex) => {
  return getBlobApi(
    `ticketAttachment/${userId}/${ticketId}/${messageId}/${attachmentIndex}`,
    {},
    "application/pdf"
  );
};
export const getTicketEmailTemplatesApi = () => getApi(`ticket-email-templates`);
export const createTicketEmailTemplateApi = (data) => postApi(`ticket-email-templates`, data);
export const updateTicketEmailTemplateApi = (id, data) => patchApi(`ticket-email-templates/${id}`, data);
export const deleteTicketEmailTemplateApi = (id) => deleteApi(`ticket-email-templates/${id}`);

export const getLeadEmailTemplatesApi = () => getApi(`/crm/lead-email-templates`);
export const createLeadEmailTemplateApi = (data) => postApi(`/crm/lead-email-templates`, data);
export const updateLeadEmailTemplateApi = (id, data) => patchApi(`/crm/lead-email-templates/${id}`, data);
export const deleteLeadEmailTemplateApi = (id) => deleteApi(`/crm/lead-email-templates/${id}`);
export const getStocksApi = () => {
  return getApi(`stocks`);
};
export const addNewStockApi = (data) => {
  return postApi(`addNewStock`, data);
};
export const updateStockApi = (stockId, stockData) => {
  return patchApi(`stocks/${stockId}`, stockData);
};
export const updateTokenApi = (tokenId, tokenData) => {
  return patchApi(`tokens/${tokenId}`, tokenData);
};
export const deleteStockApi = (stockId) => {
  return deleteApi(`stocks/${stockId}`);
};
export const getLinksApi = () => {
  return getApi(`getLinks`);
};
export const updateLinksApi = (id, enabled) => {
  return putApi(`updateLinks/${id}/${enabled}`, enabled);
};
export const deleteTicketApi = (id) => {
  return deleteApi(`deleteTicket/${id}`,);
};
export const getStakingSettingsApi = (id) => {
  return getApi(`getStakingSettings/${id}`,);
};
export const updateStakingSettingsApi = (id, settings) => {
  return patchApi(`updateStakingSettings/${id}`, settings);
};
export const deleteAllNotificationsApi = () => {
  return deleteApi(`deleteAllNotifications`);
};
export const deleteNotificationApi = (id) => {
  return deleteApi(`deleteNotification/${id}`);
};
export const getStakingRewardsApi = (id) => {
  return getApi(`getStakingRewards/${id}/stakings`);
};
export const addMyTokensApi = (userId, data) => {
  return patchFormApi(`/addMyTokens/${userId}`, data);
};
export const getAllTokensApi = (id) => {
  return getApi(`/getAllTokens/${id}`);
};
export const getMyTokensApi = (id) => {
  return getApi(`/tokens/${id}`);
};
export const getRestrictionsApi = () => {
  return getApi(`/restrictions`);
};
export const UpdateRestrictionsApi = (data) => {
  return patchApi(`/restrictionsUpdate`, data);
};
export const UpdateSubAdminPermissionsApi = (id, body) => {
  return patchApi(`/users/${id}/permissions`, body);
};
export const UpdateAdminPermissionsApi = (id, body) => {
  return patchApi(`/admin/${id}/permissions`, body);
};

export const UpdateAdminVapiConfigApi = (id, body) => {
  return patchApi(`/admin/${id}/vapi-config`, body);
};

export const GetMyVapiConfigApi = () => {
  return getApi(`/my/vapi-config`);
};

export const UpdateAdminSipConfigApi = (id, body) => {
  return patchApi(`/admin/${id}/sip-config`, body);
};

export const GetMySipConfigApi = () => {
  return getApi(`/my/sip-config`);
};

export const UpdateAdminSmtpConfigApi = (id, body) => {
  return patchApi(`/admin/${id}/smtp-config`, body);
};

export const GetMySmtpConfigApi = () => {
  return getApi(`/my/smtp-config`);
};

// ✅ Correct API functions
export const getErrorLogsApi = (page = 1) => {
  return getApi(`/getErrorLogs?page=${page}`);
};

// api service
export const deleteErrorLogsApi = (ids = []) => {
  const query = ids.length ? `?ids=${ids.join(",")}` : "";
  return deleteApi(`/deleteErrorLogs${query}`);
};
// CRM ROUTES/////////////////////////////////////////////////////
export const adminCrmLoginApi = (body) => {
  return postApi(`/crm/login`, body);
};
export const adminCrmLeadsApi = ({ params }) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/getLeads?${queryString}`);
};
export const createLeadApi = (leadData) => {
  return postApi(`/crm/createLead`, leadData);
};
export const importUsersAsLeadsApi = (userIds) => {
  return postApi(`/crm/importUsersAsLeads`, { userIds });
};
export const getLeadStatusesApi = () => getApi(`/crm/lead-statuses`);
export const getLeadViewColumnsApi = () => getApi(`/crm/lead-columns`);
export const saveLeadViewColumnsApi = (columns) => putSimpleApi(`/crm/lead-columns`, { columns });
export const createLeadStatusApi = (body) => postApi(`/crm/lead-statuses`, body);
export const updateLeadStatusApi = (id, body) => patchApi(`/crm/lead-statuses/${id}`, body);
export const deleteLeadStatusApi = (id) => deleteApi(`/crm/lead-statuses/${id}`);

export const sendLeadEmailApi = (leadId, data) => postApi(`/crm/lead/${leadId}/send-email`, data);
export const getLeadEmailHistoryApi = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
  const query = new URLSearchParams(clean).toString();
  return getApi(`/crm/lead-email-history${query ? `?${query}` : ""}`);
};
export const deleteLeadEmailHistoryApi = (ids) =>
  postApi(`/crm/lead-email-history/delete`, { ids });
export const uploadLeadsCsvApi = (formData) => {
  return postFormApi(`/crm/uploadLeads`, formData);
};
export const uploadLeadsCsvStreamApi = (formData, onProgress) => {
  return postFormStreamApi(`crm/uploadLeads`, formData, onProgress);
};
const toQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") query.set(key, value);
  });
  const text = query.toString();
  return text ? `?${text}` : "";
};
export const getLeadUploadsApi = (params) => getApi(`/crm/lead-uploads${toQuery(params)}`);
export const getLeadUploadApi = (id, params) => getApi(`/crm/lead-uploads/${id}${toQuery(params)}`);
export const acceptLeadUploadDuplicatesApi = (id, body) => postApi(`/crm/lead-uploads/${id}/accept`, body);
export const declineLeadUploadDuplicatesApi = (id, body) => postApi(`/crm/lead-uploads/${id}/decline`, body);
export const deleteLeadUploadApi = (id) => deleteApi(`/crm/lead-uploads/${id}`);

// Super admin: send leads that are with the admin back to the agent who had them before.
export const getReversalStatusesApi = () => getApi(`/crm/assignment-reversal/statuses`);
export const getReversalPreviewApi = (params) => getApi(`/crm/assignment-reversal/preview${toQuery(params)}`);
export const applyReversalApi = (body) => postApi(`/crm/assignment-reversal/apply`, body);
export const sendBackLeadsApi = (leadIds, agentId) => postApi(`/crm/assignment-reversal/send-back`, { leadIds, agentId });
export const getReversalHistoryApi = () => getApi(`/crm/assignment-reversal/history`);
export const getLeadAutomationApi = () => getApi(`/crm/lead-automation`);
export const saveLeadAutomationApi = (body) => putSimpleApi(`/crm/lead-automation`, body);
export const saveLeadAutomationAdminApi = (id, body) => putSimpleApi(`/crm/lead-automation/${id}`, body);
export const getLeadShortageAlertsApi = () => getApi(`/crm/lead-shortage-alerts`);
export const ignoreLeadShortageAlertApi = (id) => postApi(`/crm/lead-shortage-alerts/${id}/ignore`, {});
export const deleteLeadApi = (leadId) => {
  return deleteApi(`/crm/deleteLead/${leadId}`);
};
export const deleteLeadsBulkApi = (leadIds) => {
  return postApi(`/crm/bulkDeleteLeads`, { leadIds });
};
export const deleteAllLeadsApi = () => {
  return deleteApi(`/crm/deleteAllLeads`);
};
// Delete all leads with progress tracking (SSE)
export const deleteAllLeadsApiWithProgress = async (onProgress) => {
  try {
    const response = await fetch(`${baseUrl}/crm/deleteAllLeads?enableProgress=true`, {
      method: 'DELETE',
      ...getFetchAuthOptions({ 'Content-Type': 'application/json' }),
    });

    if (!response.ok) {
      throw new Error('Delete failed');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // Keep incomplete line in buffer

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const eventData = JSON.parse(line.substring(6));
            if (onProgress) {
              onProgress(eventData);
            }
            
            // If complete or error, return
            if (eventData.type === 'complete') {
              return eventData;
            } else if (eventData.type === 'error') {
              throw new Error(eventData.message || 'Failed to delete leads');
            }
          } catch (parseError) {
            console.error('Error parsing SSE data:', parseError);
            throw parseError;
          }
        }
      }
    }
  } catch (error) {
    console.error('Error deleting all leads:', error);
    throw error;
  }
};
export const updateLeadApi = (leadId, leadData) => {
  return patchApi(`/crm/editLead/${leadId}`, leadData);
};
export const exportLeadsApi = (filters = {}) => {
  return getBlobApi(`/exportLeads`,filters);
};
export const assignLeadsApi = (leadIds, agentId, options = {}) => {
  return postApi(`/crm/assignLeads`, {
    leadIds,
    agentId,
    skipPreviouslyAssigned: options.skipPreviouslyAssigned === true,
    dryRun: options.dryRun === true,
  });
};
// Super admin: clear a brand from every lead that has it (dryRun only counts them).
export const removeLeadBrandApi = (brand, options = {}) => {
  return postApi(`/crm/lead-brands/remove`, { brand, dryRun: options.dryRun === true });
};
export const bulkUpdateLeadStatusApi = (leadIds, status) => {
  return postApi(`/crm/bulkUpdateLeadStatus`, { leadIds, status });
};

export const createReminderApi = (data) => postApi(`/crm/reminders`, data);
export const getRemindersApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
    )
  ).toString();
  return getApi(`/crm/reminders${queryString ? `?${queryString}` : ''}`);
};
export const getReminderApi = (id) => getApi(`/crm/reminders/${id}`);
export const updateReminderApi = (id, data) => patchApi(`/crm/reminders/${id}`, data);
export const deleteReminderApi = (id) => deleteApi(`/crm/reminders/${id}`);
export const getTrashedRemindersApi = () => getApi(`/crm/reminders/trash`);
export const restoreReminderApi = (id) => patchApi(`/crm/reminders/${id}/restore`);
export const hardDeleteReminderApi = (id) => deleteApi(`/crm/reminders/${id}/hard-delete`);
export const getReminderBadgeCountApi = () => getApi(`/crm/reminders/badge-count`);
export const getPendingReminderNotificationsApi = () => getApi(`/crm/reminders/notifications/pending`);
export const dismissReminderNotificationApi = (id) => patchApi(`/crm/reminders/notifications/${id}/dismiss`);
export const markReminderNotificationReadApi = (id) => patchApi(`/crm/reminders/notifications/${id}/read`);

export const getStaffMessagesApi = () => getApi(`/crm/staff-messages`);
export const createStaffMessageApi = (data) => postApi(`/crm/staff-messages`, data);
export const updateStaffMessageApi = (id, data) => patchApi(`/crm/staff-messages/${id}`, data);
export const resendStaffMessageApi = (id) => postApi(`/crm/staff-messages/${id}/resend`);
export const deleteStaffMessageApi = (id) => deleteApi(`/crm/staff-messages/${id}`);
export const getPendingStaffMessagesApi = () => getApi(`/crm/staff-messages/pending`);
export const dismissStaffMessageApi = (id) => postApi(`/crm/staff-messages/${id}/dismiss`);

export const getChatAgentsApi = (search = "") => getApi(`/crm/chat/agents?search=${encodeURIComponent(search)}`);
export const getChatConversationsApi = () => getApi(`/crm/chat/conversations`);
export const getChatUnreadPopupsApi = () => getApi(`/crm/chat/unread-popups`);
export const openChatApi = (userId) => postApi(`/crm/chat/conversations`, { userId });
export const getChatMessagesApi = (id, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return getApi(`/crm/chat/conversations/${id}/messages${query ? `?${query}` : ""}`);
};
export const sendChatMessageApi = async (formData, onProgress) => {
  try {
    const response = await axiosService.post(`/crm/chat/messages`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
      onUploadProgress: (event) => {
        if (onProgress && event.total) onProgress(Math.round((event.loaded / event.total) * 100));
      },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data || { success: false, msg: error.message };
  }
};
export const editChatMessageApi = (id, data) => patchApi(`/crm/chat/messages/${id}`, data);
export const hideChatMessageApi = (id) => postApi(`/crm/chat/messages/${id}/hide`);
export const deleteChatMessageApi = (id, data) => postApi(`/crm/chat/messages/${id}/delete`, data);
export const reactChatMessageApi = (id, emoji) => postApi(`/crm/chat/messages/${id}/react`, { emoji });
export const seenChatApi = (id) => postApi(`/crm/chat/conversations/${id}/seen`);
export const typingChatApi = (id, active) => postApi(`/crm/chat/conversations/${id}/typing`, { active });
export const deliveredChatApi = (messageIds) => postApi(`/crm/chat/receipts/delivered`, { messageIds });
export const removeChatConversationApi = (id) => postApi(`/crm/chat/conversations/${id}/remove`);
export const flagChatConversationApi = (id, field) => postApi(`/crm/chat/conversations/${id}/flag`, { field });
export const getAdminChatConversationsApi = () => getApi(`/crm/chat/admin/conversations`);
export const getChatCallsApi = (conversationId, options = {}) => {
  const params = new URLSearchParams();
  if (conversationId) params.set("conversationId", conversationId);
  if (options.admin) params.set("admin", "1");
  const query = params.toString();
  return getApi(`/crm/chat/calls${query ? `?${query}` : ""}`);
};
export const getChatRecycleApi = () => getApi(`/crm/chat/admin/recycle`);
export const getLeadListStatsApi = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );
  const query = new URLSearchParams(clean).toString();
  return getApi(`/crm/lead-list-stats${query ? `?${query}` : ""}`);
};
export const clearChatRecycleConversationApi = (id) => deleteApi(`/crm/chat/admin/recycle/conversations/${id}`);
export const restoreChatMessageApi = (id) => postApi(`/crm/chat/admin/messages/${id}/restore`);
export const deleteChatRecycleMessageApi = (id) => deleteApi(`/crm/chat/admin/messages/${id}`);

export const getCrmNotificationsApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
    )
  ).toString();
  return getApi(`/crm/notifications${queryString ? `?${queryString}` : ''}`);
};
export const getCrmNotificationUnreadCountApi = () => getApi(`/crm/notifications/unread-count`);
export const markCrmNotificationReadApi = (id) => patchApi(`/crm/notifications/${id}/read`);
export const markAllCrmNotificationsReadApi = () => patchApi(`/crm/notifications/read-all`);
export const deleteCrmNotificationApi = (id) => deleteApi(`/crm/notifications/${id}`);
export const deleteAllCrmNotificationsApi = () => deleteApi(`/crm/notifications/delete-all`);

// Recycle Bin APIs
export const listDeletedLeadsApi = (params) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/recycle/list?${queryString}`);
};
export const restoreLeadApi = (leadId) => {
  return patchApi(`/crm/recycle/restore/${leadId}`);
};
export const hardDeleteLeadApi = (leadId) => {
  return deleteApi(`/crm/recycle/hardDelete/${leadId}`);
};
export const bulkRestoreLeadsApi = (leadIds) => {
  return postApi(`/crm/recycle/bulkRestore`, { leadIds });
};
export const bulkHardDeleteLeadsApi = (leadIds) => {
  return postApi(`/crm/recycle/bulkHardDelete`, { leadIds });
};

// Restore all leads with progress tracking (SSE)
export const restoreAllLeadsApiWithProgress = async (onProgress) => {
  try {
    const response = await fetch(`${baseUrl}/crm/recycle/restoreAll`, {
      method: 'POST',
      ...getFetchAuthOptions({ 'Content-Type': 'application/json' }),
    });

    if (!response.ok) {
      throw new Error('Restore failed');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // Keep incomplete line in buffer

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const eventData = JSON.parse(line.substring(6));
            if (onProgress) {
              onProgress(eventData);
            }
            
            // If complete or error, return
            if (eventData.type === 'complete') {
              return eventData;
            } else if (eventData.type === 'error') {
              throw new Error(eventData.message || 'Failed to restore leads');
            }
          } catch (parseError) {
            console.error('Error parsing SSE data:', parseError);
            throw parseError;
          }
        }
      }
    }
  } catch (error) {
    console.error('Error restoring all leads:', error);
    throw error;
  }
};

// Delete all leads with progress tracking (SSE)
export const hardDeleteAllLeadsApiWithProgress = async (onProgress) => {
  try {
    const response = await fetch(`${baseUrl}/crm/recycle/hardDeleteAll`, {
      method: 'DELETE',
      ...getFetchAuthOptions({ 'Content-Type': 'application/json' }),
    });

    if (!response.ok) {
      throw new Error('Delete failed');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop(); // Keep incomplete line in buffer

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const eventData = JSON.parse(line.substring(6));
            if (onProgress) {
              onProgress(eventData);
            }
            
            // If complete or error, return
            if (eventData.type === 'complete') {
              return eventData;
            } else if (eventData.type === 'error') {
              throw new Error(eventData.message || 'Failed to delete leads');
            }
          } catch (parseError) {
            console.error('Error parsing SSE data:', parseError);
            throw parseError;
          }
        }
      }
    }
  } catch (error) {
    console.error('Error permanently deleting all leads:', error);
    throw error;
  }
};

// Fallback API calls (without progress)
export const restoreAllLeadsApi = () => {
  return postApi(`/crm/recycle/restoreAll`);
};
export const hardDeleteAllLeadsApi = () => {
  return deleteApi(`/crm/recycle/hardDeleteAll`);
};

// Activate lead(s) to convert them into users
export const activateLeadApi = (leadId) => {
  return postApi(`/crm/activateLead/${leadId}`);
};

export const activateLeadsBulkApi = (leadIds, sessionId) => {
  return postApi(`/crm/bulkActivateLeads`, { leadIds, sessionId });
};

// Get activation progress by session ID
export const getActivationProgressApi = (sessionId) => {
  return getApi(`/crm/activation/progress/${sessionId}`);
};

// Failed emails management
export const getFailedEmailsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/failedEmails?${queryString}`);
};

export const resendFailedEmailsApi = (emailIds) => {
  return postApi(`/crm/failedEmails/resend`, { emailIds });
};

export const deleteFailedEmailsApi = (emailIds) => {
  return postApi(`/crm/failedEmails/delete`, { emailIds });
};

// Activity/Stream APIs
export const getLeadStreamApi = (leadId) => {
  return getApi(`/crm/lead/${leadId}/stream`);
};

export const getLeadActivitiesApi = (leadId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/lead/${leadId}/activities?${queryString}`);
};

export const getLeadWithActivityApi = (leadId) => {
  return getApi(`/crm/leads/${leadId}/stream`);
};

export const addLeadCommentApi = (leadId, comment) => {
  return postApi(`/crm/lead/${leadId}/comment`, { comment });
};

// ✅ NEW: Enhanced Comment Features
export const editCommentApi = (leadId, commentId, content, editReason) => {
  return patchApi(`/crm/lead/${leadId}/comment/${commentId}/edit`, { content, editReason });
};

export const deleteCommentApi = (leadId, commentId) => {
  return deleteApi(`/crm/lead/${leadId}/comment/${commentId}/delete`);
};

export const toggleLikeCommentApi = (leadId, commentId) => {
  return postApi(`/crm/lead/${leadId}/comment/${commentId}/like`, {});
};

export const togglePinCommentApi = (leadId, commentId) => {
  return postApi(`/crm/lead/${leadId}/comment/${commentId}/pin`, {});
};

export const toggleImportantCommentApi = (leadId, commentId) => {
  return postApi(`/crm/lead/${leadId}/comment/${commentId}/important`, {});
};

export const addQuoteReplyApi = (leadId, commentId, content) => {
  return postApi(`/crm/lead/${leadId}/comment/${commentId}/quote-reply`, { content });
};

export const addNestedReplyApi = (leadId, commentId, content) => {
  return postApi(`/crm/lead/${leadId}/comment/${commentId}/reply`, { content });
};

export const getCommentHistoryApi = (leadId, commentId) => {
  return getApi(`/crm/lead/${leadId}/comment/${commentId}/history`);
};

export const getNestedRepliesApi = (leadId, commentId) => {
  return getApi(`/crm/lead/${leadId}/comment/${commentId}/replies`);
};

export const searchCommentsApi = (leadId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/lead/${leadId}/comments/search?${queryString}`);
};

// Activate bulk leads with progress tracking (SSE) - NEW APPROACH
// This ONLY creates users, emails are queued for background processing
export const activateLeadsBulkWithProgress = async (leadIds, sendWelcomeEmail = true, onProgress) => {try {
    const response = await fetch(`${baseUrl}/crm/bulkActivateLeads`, {
      method: 'POST',
      ...getFetchAuthOptions({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ leadIds, sendWelcomeEmail })
    });if (!response.ok) {
      const errorText = await response.text();
      console.error('❌ Response not OK:', errorText);
      throw new Error(`Activation failed: ${response.status} ${errorText}`);
    }const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    while (true) {
      const { done, value } = await reader.read();
      
      if (done) {break;
      }

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop();

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const eventData = JSON.parse(line.substring(6));if (onProgress) {
              onProgress(eventData);
            }
            
            if (eventData.type === 'complete') {return eventData;
            } else if (eventData.type === 'error') {
              console.error('❌ SSE error event:', eventData);
              throw new Error(eventData.message || 'Failed to activate leads');
            }
          } catch (parseError) {
            console.error('❌ Error parsing SSE data:', parseError, 'Line:', line);
            throw parseError;
          }
        }
      }
    }
  } catch (error) {
    console.error('❌ activateLeadsBulkWithProgress error:', error);
    throw error;
  }
};

// Get email queue status
export const getEmailQueueStatusApi = () => {
  return getApi('/crm/emailQueue/status');
};

// Trigger email queue processing manually
export const processEmailQueueApi = () => {
  return postApi('/crm/emailQueue/process', {});
};

// Clear email queue (superadmin only) - Fix for stuck badges
export const clearEmailQueueApi = () => {
  return postApi('/crm/emailQueue/clear', {});
};

// ===========================
// MLM REFERRAL SYSTEM APIs
// ===========================

// Public endpoint - verify referral code
export const verifyReferralCodeApi = (code) => {
  return getApi(`referral/verify/${code}`);
};

// User endpoints
export const getMyReferralCodeApi = () => {
  return getApi('referral/my-code');
};

export const getMyReferralTreeApi = () => {
  return getApi('referral/my-tree');
};

export const getMyReferralsApi = () => {
  return getApi('referral/my-referrals');
};

export const getMyEarningsApi = () => {
  return getApi('referral/my-earnings');
};

// Admin endpoints
export const getAllReferralsAdminApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`referral/admin/all${queryString ? `?${queryString}` : ''}`);
};

export const getSystemStatisticsApi = () => {
  return getApi('referral/admin/statistics');
};

export const getUserReferralDetailsApi = (userId) => {
  return getApi(`referral/admin/user/${userId}`);
};

export const activateUserAndSetCommissionApi = (userId, data) => {
  return postApi(`referral/admin/activate/${userId}`, data);
};

export const updateUserAffiliateStatusApi = (userId, data) => {
  return patchApi(`referral/admin/status/${userId}`, data);
};

export const addCommissionManuallyApi = (userId, data) => {
  return postApi(`referral/admin/commission/${userId}`, data);
};


// Call-related API functions
export const initiateCallApi = (leadId, phoneNumber) => {
  return postApi(`/crm/call/initiate`, { leadId, phoneNumber });
};

export const bulkCallLeadsApi = (leadIds, options = {}) => {
  return postApi(`/crm/call/bulk`, { leadIds, options });
};

export const scheduleCallApi = (leadId, phoneNumber, scheduledAt) => {
  return postApi(`/crm/call/schedule`, { leadId, phoneNumber, scheduledAt });
};

export const getCallStatusApi = (sessionId) => {
  return getApi(`/crm/call/status/${sessionId}`);
};

export const getCallHistoryApi = (leadId) => {
  return getApi(`/crm/call/history/${leadId}`);
};

export const cancelCallApi = (sessionId) => {
  return postApi(`/crm/call/cancel/${sessionId}`);
};

export const deleteCallApi = (callId) => {
  return deleteApi(`/crm/call/${callId}`);
};

export const deleteCallsBulkApi = (callIds) => {
  return deleteApi(`/crm/call`, { data: { callIds } });
};

export const deleteCallHistoryApi = (leadId) => {
  return deleteApi(`/crm/call`, { data: { leadId } });
};

export const deleteCallsByStatusApi = (status) => {
  return deleteApi(`/crm/call`, { data: { status } });
};

export const getCallStatisticsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/call/statistics${queryString ? `?${queryString}` : ''}`);
};

export const getActiveCallsApi = () => {
  return getApi(`/crm/call/active`);
};

export const getCallQueueStatusApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/call/queue/status${queryString ? `?${queryString}` : ''}`);
};

export const pauseCallQueueApi = () => {
  return postApi(`/crm/call/queue/pause`);
};

export const resumeCallQueueApi = () => {
  return postApi(`/crm/call/queue/resume`);
};

export const retryFailedCallApi = (callId) => {
  return postApi(`/crm/call/retry`, { callId });
};

export const getCompletedCallsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/call/completed${queryString ? `?${queryString}` : ''}`);
};

export const getCallLogsApi = (callId, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`/crm/call/${callId}/logs${queryString ? `?${queryString}` : ''}`);
};

// AI Instructions API
export const getAiInstructionsApi = () => {
  return getApi(`/crm/ai-instructions`);
};

export const updateAiInstructionsApi = (data) => {
  return putSimpleApi(`/crm/ai-instructions`, data);
};

export const getCrmDocumentCategoriesApi = () => getApi('/crm/documents/categories');

export const getCrmDocumentsApi = (params = {}) => {
  const queryString = new URLSearchParams(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  ).toString();
  return getApi(`/crm/documents${queryString ? `?${queryString}` : ''}`);
};

export const uploadCrmDocumentApi = (formData) => postFormApi('/crm/documents', formData);

export const updateCrmDocumentApi = (id, data) => patchApi(`/crm/documents/${id}`, data);

export const deleteCrmDocumentApi = (id) => deleteApi(`/crm/documents/${id}`);

export const downloadCrmDocumentApi = (id) =>
  getBlobApi(`/crm/documents/${id}/download`, {}, 'application/octet-stream');

export const restartServerApi = () => {
  return postApi("restartServer", {});
};

export const getUserEuroBankAccountApi = (userId) => getApi(`users/${userId}/euro-bank-account`);

export const upsertUserEuroBankAccountApi = (userId, data) =>
  putSimpleApi(`users/${userId}/euro-bank-account`, data);

export const deleteUserEuroBankAccountApi = (userId) =>
  deleteApi(`users/${userId}/euro-bank-account`);

export const getUserUsdBankAccountApi = (userId) => getApi(`users/${userId}/usd-bank-account`);

export const upsertUserUsdBankAccountApi = (userId, data) =>
  putSimpleApi(`users/${userId}/usd-bank-account`, data);

export const deleteUserUsdBankAccountApi = (userId) =>
  deleteApi(`users/${userId}/usd-bank-account`);

export const getUserChfBankAccountApi = (userId) => getApi(`users/${userId}/chf-bank-account`);

export const upsertUserChfBankAccountApi = (userId, data) =>
  putSimpleApi(`users/${userId}/chf-bank-account`, data);

export const deleteUserChfBankAccountApi = (userId) =>
  deleteApi(`users/${userId}/chf-bank-account`);

export const getUserDkkBankAccountApi = (userId) => getApi(`users/${userId}/dkk-bank-account`);

export const upsertUserDkkBankAccountApi = (userId, data) =>
  putSimpleApi(`users/${userId}/dkk-bank-account`, data);

export const deleteUserDkkBankAccountApi = (userId) =>
  deleteApi(`users/${userId}/dkk-bank-account`);

export const chatbotApi = (data) => {
  return postApi("chatbot/message", data);
};

export const createChatbotSessionApi = (data) => {
  return postApi("chatbot/session", data);
};

export const getChatbotSessionMessagesApi = (sessionId) => {
  return getApi(`chatbot/session/${sessionId}/messages`);
};

export const clearChatbotApi = (data) => {
  return postApi("chatbot/clear", data);
};

export const sendChatbotEmailApi = (data) => {
  return postApi("chatbot/send-email", data);
};

export const getMyLoanApplicationApi = () => getApi("loanApplication/my");
export const saveMyLoanApplicationApi = (data) => patchApi("loanApplication/my", data);
export const submitMyLoanApplicationApi = (data) => postApi("loanApplication/submit", data);
export const submitTaxAssessmentApi = (data) => postApi("taxAssessment/submit", data);
export const uploadLoanDocumentApi = (formData) => postFormApi("loanApplication/upload", formData);
export const getLoanApplicationByUserApi = (userId) => getApi(`loanApplication/user/${userId}`);
export const getLoanDocumentApi = (userId, docSlot) =>
  getBlobApi(`loanDocument/${userId}/${docSlot}`, {}, "application/pdf");
export const getAllLoanApplicationsApi = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return getApi(`loanApplications${queryString ? `?${queryString}` : ""}`);
};
export const updateLoanApplicationStatusApi = (id, data) =>
  patchApi(`loanApplication/${id}/status`, data);
export const deleteLoanApplicationApi = (id) => deleteApi(`loanApplication/${id}`);
